import { type PayloadAction } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import {
  type FetchingItemsState,
  createFetchingItemsSlice,
} from "features/Application/slices/createFetchingItemsSlice";
import { type ScormOverview } from "../../types/models";
import { findIndex } from "lodash";

export interface OverviewState extends FetchingItemsState<ScormOverview> {
  selected: number[];
}

export const initialState: OverviewState = {
  isLoading: false,
  items: [],
  itemsCount: 0,
  selected: [],
};

const slice = createFetchingItemsSlice({
  initialState,
  namePayload: {
    entity: ReducerEntityPrefixTypes.Scorm,
    name: "Overview",
    namespace: ReducerNamespaceTypes.Library,
  },
  reducers: {
    setSelected: (state, action: PayloadAction<number[]>) => {
      state.selected = action.payload;
    },
    updateScormBegin(state) {
      state.isLoading = true;
    },
    updateScormSuccess(state, action: PayloadAction<ScormOverview>) {
      const index = findIndex(state.items, { id: action.payload.id });
      index >= 0 &&
        state.items.splice(index, 1, {
          ...state.items[index],
          ...action.payload,
          publisher: state.items[index].publisher,
        });
      state.isLoading = false;
    },
  },
});

export const { fetchBegin, fetchFailure, fetchSuccess, reset, setSelected, updateScormBegin, updateScormSuccess } =
  slice.actions;

export default slice.reducer;
